module.exports = __webpack_public_path__ + "static/media/blog7.e1e8213e.jpg";